import React, { useState, useRef, useEffect } from "react";
import "./OuterFiltersDropDown.css";
import { DownIcon, UpIcon } from "../../components/FilterModal/Icons.tsx";
import { useUserContext } from "../../context/UserContext.tsx";

export default function POSDropDown({selectedPOSName, setSelectedPOSName, filterVal, posId, setPosId, filters }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const itemRef = useRef();
  const { posInfo, globalstorevalue } = useUserContext();

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      const activeItem = itemRef.current?.querySelector(".active");
      if (activeItem && itemRef.current) {
        itemRef.current.scrollTop = activeItem.offsetTop - 72;
      }
    }
  }, [isOpen]);

  // Reset to "All POS" when store changes - but don't trigger API call
  useEffect(() => {
    setSelectedPOSName("All POS");
  }, [globalstorevalue]);

  // Handle selecting an individual POS
  const handlePosSelection = (selectedPos) => {
    setSelectedPOSName(selectedPos.name || "POS");
    setIsOpen(false);
    setPosId(selectedPos._id);
  };

  // Handle selecting "All POS"
  const handleAllPosSelection = () => {
    setSelectedPOSName("All POS");
    setIsOpen(false);
    setPosId("");
  };

  // POS options from context (array of POS objects)
  const posOptions = posInfo || [];

  // Keep selectedName in sync when filters.posId changes externally
  useEffect(() => {
    if (!posId) {
      setSelectedPOSName("All POS");
      return;
    }
    const matched = posOptions.find((p) => p._id === posId);
    if (matched) setSelectedPOSName(matched.name);
  }, [posId, posOptions]);

  return (
    <div className={`dropdown-wrapper`} ref={dropdownRef}>
      <button
        style={{ fontSize: "12.5px" }}
        className={`TransactionsPOSDropDownBtn ${filters.posId ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedPOSName}
        {!isOpen ? <DownIcon /> : <UpIcon />}
      </button>

      {isOpen && (
        <div className="dropdown-list" ref={itemRef}>
          {/* All POS option */}
          <button
            onClick={handleAllPosSelection}
            className={`dropdown-item ${selectedPOSName === "All POS" ? "active" : ""}`}
          >
            All POS
          </button>

          {/* Individual POS options */}
          {posOptions.map((pos) => (
            <button
              key={pos._id}
              onClick={() => handlePosSelection(pos)}
              className={`dropdown-item ${pos._id === posId ? "active" : ""}`}
            >
              {pos.name}
            </button>
          ))} 
        </div>
      )}
    </div>
  );
}
